// extracted by mini-css-extract-plugin
module.exports = {"container":"_2Ocovu1bWA2OepYLm6G1_w"};